var _rect, _rect2, _mask, _rect3, _rect4, _rect5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGalyan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 15,
    fill: "url(#paint0_linear_98_864)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 25.4419,
    width: 39.9486,
    height: 44.5581,
    rx: 8,
    fill: "#EEF0FC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_98_864",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.7554,
    y: 14,
    width: 18.4378,
    height: 19.9743,
    rx: 4
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7554,
    y: 14,
    width: 18.4378,
    height: 19.9743,
    rx: 4,
    stroke: "#EEF0FC",
    strokeWidth: 12,
    mask: "url(#path-3-inside-1_98_864)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 49.6987,
    width: 39.9486,
    height: 4.24985,
    fill: "#633BF9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 41.1992,
    width: 39.9486,
    height: 4.24985,
    fill: "#633BF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_864",
    x1: -35.9133,
    y1: 34.9521,
    x2: 33.991,
    y2: 106.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542FE4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalyan);
export default __webpack_public_path__ + "static/media/galyan.ecf5572b3e24f24000770acbd1607ec8.svg";
export { ForwardRef as ReactComponent };